export const formatPhoneNumber = (phone) => {
  if (!phone) return "";
  const cleaned = phone.replace(/\D/g, "");
  if (cleaned.length <= 10) {
    const area = cleaned.slice(0, 3);
    const prefix = cleaned.slice(3, 6);
    const line = cleaned.slice(6, 10);
    let formatted = "";
    if (area) formatted += "(" + area + ")";
    if (prefix) formatted += prefix;
    if (line) formatted += "-" + line;
    return formatted;
  } else {
    const limited = cleaned.slice(0, 14);
    const area = limited.slice(0, 3);
    const prefix = limited.slice(3, 6);
    const line = limited.slice(6, 10);
    const ext = limited.slice(10, 14);
    let formatted = "";
    if (area) formatted += "(" + area + ")";
    if (prefix) formatted += prefix;
    if (line) formatted += "-" + line;
    if (ext) formatted += " ext. " + ext;
    return formatted;
  }
};
